import { t } from "i18next";
import TertiaryButton from "./TertiaryButton";
import { ButtonPropTypes } from "./Button";

// const CancelButton = (props) => {
//   return (
//     <button
//       className={`px-16 rounded-full py-4 bg-white text-sm font-bold text-Eclipse ml-4 border border-Dark-Grey disabled:bg-opacity-40 ${
//         props.className ? props.className : ""
//       }`}
//       onClick={props.onClick}
//       disabled={props.disabled}
//     >
//       {t("_CANCEL")}
//     </button>
//   );
// };

const CancelButton = (props) => <TertiaryButton text={t("_CANCEL")} {...props}/>;
CancelButton.propTypes = ButtonPropTypes;
export default CancelButton;
